import { Routes } from '@angular/router';
// [[Componentes da Aplicação]]
import {
  AboutUsComponent,
  HomeComponent,
  SearchComponent,
  SalesmanComponent,
  SpecialViewComponent,
  SubscriptionComponent,
  // [Kit]
  SubscriptionKitViewComponent,
  // [Voucher]
  VoucherViewComponent,
} from './index';
// []
export const ModuleRoutes: Routes = [
  {
    path: 'page',
    children: [
      {
        path: 'nos',
        component: AboutUsComponent,
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 's',
        component: SearchComponent,
      },
      {
        path: 's/:type/:haystack',
        component: SearchComponent,
      },
      {
        path: 'salesman',
        component: SalesmanComponent,
      },
      {
        path: 'special/:url_handle',
        component: SpecialViewComponent,
      },
    ],
  },
  {
    path: 'subscription',
    children: [
      {
        path: '',
        component: SubscriptionComponent,
      },
      {
        path: 'kit/:id/view',
        component: SubscriptionKitViewComponent,
      },
    ],
  },
  {
    path: 'voucher',
    children: [
      {
        path: ':name',
        component: VoucherViewComponent,
      },
    ],
  },
];
